<template>
    <div class="">
        <div class="w-full h-[32em] bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/paryaschie-potolki-scaled.jpg')] mb-6 flex justify-center items-center">
            <div class="rounded-full bg-dim_gold_2 w-14 h-14 flex items-center justify-center">
                <img src="@/assets/img/360.svg" class="h-8">
            </div>
        </div>
    </div>
</template>
